import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mb-4" }
const _hoisted_2 = { class: "col-md-6 col-lg-6 col-xl-6 col-xxl-6" }
const _hoisted_3 = { class: "col-md-6 col-lg-6 col-xl-6 col-xxl-6" }
const _hoisted_4 = { class: "col-md-6 col-lg-6 col-xl-6 col-xxl-6" }
const _hoisted_5 = { class: "col-md-6 col-lg-6 col-xl-6 col-xxl-6" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "col-md-6 d-flex align-items-center" }
const _hoisted_8 = { class: "form-check form-check-inline" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label" }, "Якорный поставщик", -1)
const _hoisted_10 = { class: "col-md-6 col-lg-6 col-xl-6 col-xxl-6" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-12 text-center" }

import { onMounted, reactive, computed } from "vue";
import { useModal } from "@/composables/useModal";
import api from "@/api";
import { CATEGORY_TYPE_COLLECTION } from '@depo/constants/contractor';


export default /*#__PURE__*/_defineComponent({
  __name: 'SupplierModal',
  props: {
    id: {
        type: String,
        default: '',
    },
},
  setup(__props) {

const props = __props;

const modal = useModal(props.id);

const state = reactive({
    title: '',
    btn: '',
    id: 0,
    name: '',
    address: '',
    contacts: '',
    info: '',
    bin: '',
    isAnchorSupplier: false,
    visibleErrors: false,
    loader: false,
    categoryTypes: [],
});

const isNameError = computed(() => !state.name.length);
const isAddressError = computed(() => !state.address || !state.address.length);
const isBinError = computed(() => !state.bin || !state.bin.length);
const isInfoError = computed(() => !state.info || !state.info.length);
const isContactsError = computed(() => !state.contacts || !state.contacts.length);
const isCategoryTypeError = computed(() => !state.categoryTypes.length);

function handleCategoryTypesSelect(_c: any) {
    state.categoryTypes = _c.map((c: any) => c.id);
}

const errors = computed(() => {
    return isNameError.value ||
        isAddressError.value ||
        isBinError.value ||
        isInfoError.value ||
        isCategoryTypeError.value ||
        isContactsError.value;
});

onMounted(() => {
    if (modal.data.type === 'add') {
        state.title = 'Добавление поставщика';
        state.btn = 'Добавить';
    } else {
        state.title = 'Редактирование поставщика';
        state.btn = 'Сохранить';

        state.id = modal.data.supplier.id;
        state.name = modal.data.supplier.name;
        state.address = modal.data.supplier.address;
        state.contacts = modal.data.supplier.contacts;
        state.info = modal.data.supplier.info;
        state.bin = modal.data.supplier.bin;
        state.isAnchorSupplier = modal.data.supplier.isAnchorSupplier;
        state.categoryTypes = modal.data.supplier.categoryTypes;
    }
});

function send() {
    if (errors.value) {
        state.visibleErrors = true;
    } else {
        state.visibleErrors = false;
        state.loader = true;
        if (modal.data.type === 'add') {
            api.supplier.create({
                name: state.name,
                address: state.address,
                contacts: state.contacts,
                info: state.info,
                bin: state.bin,
                isAnchorSupplier: state.isAnchorSupplier,
                categoryTypes: state.categoryTypes,
            }).then((r: any) => {
                if (r.data) {
                    modal.ok({
                        supplier: r.data,
                    });
                }
            }).finally(() => state.loader = false);
        } else {
            api.supplier.update({
                id: state.id,
                name: state.name,
                address: state.address,
                contacts: state.contacts,
                info: state.info,
                bin: state.bin,
                isAnchorSupplier: state.isAnchorSupplier,
                categoryTypes: state.categoryTypes,
            }).then((r: any) => {
                if (r.data) {
                    modal.ok({
                        supplier: r.data,
                    });
                }
            }).finally(() => state.loader = false);
        }
    }
}

function ok() {
    modal.ok({
        asd: 123,
    });
}

function close() {
    modal.close();
}

function cancel() {
    modal.cancel({
        zxc: 123,
    });
}

return (_ctx: any,_cache: any) => {
  const _component_loader_ui = _resolveComponent("loader-ui")!
  const _component_input_ui = _resolveComponent("input-ui")!
  const _component_form_group_ui = _resolveComponent("form-group-ui")!
  const _component_select_ui = _resolveComponent("select-ui")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_modal_ui = _resolveComponent("modal-ui")!

  return (_openBlock(), _createBlock(_component_modal_ui, {
    id: __props.id,
    size: "modal-md",
    title: state.title
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "loader",
        onSubmit: _withModifiers(send, ["prevent"])
      }, [
        _createVNode(_component_loader_ui, {
          "is-show": state.loader
        }, null, 8, ["is-show"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Укажите название",
              label: "Название",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  modelValue: state.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.name) = $event)),
                  "is-invalid": state.visibleErrors && isNameError.value,
                  placeholder: "Название"
                }, null, 8, ["modelValue", "is-invalid"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Укажите адрес",
              label: "Адрес",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  modelValue: state.address,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.address) = $event)),
                  "is-invalid": state.visibleErrors && isAddressError.value,
                  placeholder: "Адрес"
                }, null, 8, ["modelValue", "is-invalid"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Укажите БИН",
              label: "БИН",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  modelValue: state.bin,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.bin) = $event)),
                  "is-invalid": state.visibleErrors && isBinError.value,
                  placeholder: "БИН"
                }, null, 8, ["modelValue", "is-invalid"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Укажите контакты",
              label: "Контакты",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  modelValue: state.contacts,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((state.contacts) = $event)),
                  "is-invalid": state.visibleErrors && isContactsError.value,
                  placeholder: "Контакты"
                }, null, 8, ["modelValue", "is-invalid"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Укажите инфо",
              label: "Инфо",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  modelValue: state.info,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((state.info) = $event)),
                  "is-invalid": state.visibleErrors && isInfoError.value,
                  placeholder: "Инфо"
                }, null, 8, ["modelValue", "is-invalid"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((state.isAnchorSupplier) = $event)),
                class: "form-check-input",
                type: "checkbox"
              }, null, 512), [
                [_vModelCheckbox, state.isAnchorSupplier]
              ]),
              _hoisted_9
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Укажите признак",
              label: "Признак контрагента"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_select_ui, {
                  "is-invalid": state.visibleErrors && isCategoryTypeError.value,
                  multiple: true,
                  options: _unref(CATEGORY_TYPE_COLLECTION).map(c => ({ name: c, id: c })),
                  placeholder: "Признак",
                  values: state.categoryTypes,
                  onOnUpdated: handleCategoryTypesSelect
                }, null, 8, ["is-invalid", "options", "values"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_button_ui, { "button-class": "btn-primary" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(state.btn), 1)
              ]),
              _: 1
            })
          ])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["id", "title"]))
}
}

})